import { render, staticRenderFns } from "./CustomerPricing.vue?vue&type=template&id=1103dc35&"
import script from "./CustomerPricing.js?vue&type=script&lang=js&"
export * from "./CustomerPricing.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports